import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=1cad692e&scoped=true&"
import script from "./PartnersList.vue?vue&type=script&lang=js&"
export * from "./PartnersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cad692e",
  null
  
)

export default component.exports